export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8638.5733fba3.jpg";